import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import { commonQuestionsGroups, GroupQuestions, instructorsQuestionsGroups } from './data/questions';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const Tutorial = Loader(lazy(() => import('src/content/tutorial/index')));

const routes: RouteObject[] = [
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/tutorial" replace />
      },
      {
        path: 'tutorial',
        // element: <Tutorial />,
        children: [
          {
            path: '',
            element: <Tutorial />
          },
          ...[...commonQuestionsGroups, ...instructorsQuestionsGroups].map((groupQuestion: GroupQuestions) => {
            return {
              path: groupQuestion.id.toString(),
              element: <Tutorial groupQuestion={groupQuestion.id} />
            };
          })
        ]
      }
    ]
  }
];

export default routes;
